import { TEXT_TYPE_REGEXP } from '../constants';
import { getChinaCode } from './area-code';

export const verifyPhone = (phone: string, isInternational?: boolean) => {
    if (!isInternational) {
        return new RegExp(TEXT_TYPE_REGEXP.MOBILE).test(phone);
    }
    // 校验国际手机号
    const match = phone.split('-');
    const areaCode = match[0];
    const mobileNum = match[1] || '';
    if (areaCode === getChinaCode()) {
        return new RegExp(TEXT_TYPE_REGEXP.MOBILE).test(mobileNum);
    } else {
        return new RegExp(TEXT_TYPE_REGEXP.INTER_MOBILE).test(phone);
    }
};
